module.exports = __webpack_public_path__ + "static/what-is-one9-782f72713aa5aa00b6bcf6fd30445d53.jpg";